export enum ApiStatusEnum {
  SUCCESS = 'success',
  ERROR = 'error'
}
